/* ============================================
                  PAGE TRANSLATION
   ============================================ */
import translateLogin from '../../translations/zh/login/translateLogin';
import translatePlaceholder from '../../translations/zh/placeholder/translatePlaceholder';
import translateAlt from '../../translations/zh/alt/translateAlt';
import translateTitle from '../../translations/zh/title/translateTitle';
import translateFormOverview from '../../translations/zh/formOverview/translateFormOverview';
import translateDropdown from '../../translations/zh/dropdown/translateDropdown';
import translateDataSources from '../../translations/zh/dataSources/translateDataSources';
import translateCountryNames from '../../translations/zh/countryNames/translateCountryNames';
import translateAlertMsg from '../../translations/zh/alertMsg/translateAlertMsg';
import translateNavigation from '../../translations/zh/navigation/translateNavigation';
import translateDashboard from '../../translations/zh/dashboard/translateDashboard';
import translateCountrySelection from '../../translations/zh/countrySelection/translateCountrySelection';
import translateDataSourceSelection from '../../translations/zh/dataSourceSelection/translateDataSourceSelection';
import translateBtn from '../../translations/zh/btn/translateBtn';
import translateSearchVerification from '../../translations/zh/searchVerification/translateSearchVerification';
import translateReuse from '../../translations/zh/reuse/translateReuse';
import translateTransactionHistory from '../../translations/zh/transactionHistory/translateTransactionHistory';
import translateDocumentLibrary from '../../translations/zh/documentLibrary/translateDocumentLibrary';
import translateBiometrics from '../../translations/zh/biometrics/translateBiometrics';
import translatePasswordDistro from '../../translations/zh/passwordDistro/translatePasswordDistro';

/* ============================================
                     TRANSLATE TO ENGLISH
      ============================================ */
const zh = {
  translateLogin,
  translatePlaceholder,
  translateAlt,
  translateTitle,
  translateFormOverview,
  translateDropdown,
  translateDataSources,
  translateCountryNames,
  translateAlertMsg,
  translateNavigation,
  translateDashboard,
  translateCountrySelection,
  translateDataSourceSelection,
  translateBtn,
  translateSearchVerification,
  translateReuse,
  translateTransactionHistory,
  translateDocumentLibrary,
  translateBiometrics,
  translatePasswordDistro,
};

export default zh;
